import { styled, Box } from "@mui/material";

const borderWidth = 3;

export const AvatarContainer = styled(Box)(({ theme }) => ({
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: theme.shape.borderRadius,
    padding: 15,
    overflow: "hidden",
    border: `${borderWidth}px solid transparent`,
    transition: "border-color 0.2s",
}));

export const SpeakingIndicatorOverlay = styled(Box)(({ theme }) => ({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    border: `${borderWidth}px solid ${theme.palette.background.default}`,
    transition: "border-color 0.2s",
    borderRadius: theme.shape.borderRadius,
    pointerEvents: "none",
}));

export const SpeakingIndicatorOverlaySpeaking = styled(SpeakingIndicatorOverlay)(({ theme }) => ({
    borderColor: theme.palette.primary.main,
}));

export const MenuButton = styled(Box)({
    position: "absolute",
    top: 6,
    right: 5,
    opacity: 0,
    cursor: "pointer",
    transition: "opacity 1s",
    fontSize: "1.2rem",
    padding: "0 6px",
    lineHeight: "40%",
});
